import axios from 'axios';
import Objects from "../utils/Objects";

export default class HttpRequest {

  _basePath = '';

  constructor() {
  }

  putS3(url, fileName, file) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', url);
      xhr.setRequestHeader('Content-Type', 'image/jpeg');
      xhr.onload = () => {
        if (xhr.status !== 200) {
          reject(
            new Error(
              `Request failed. Status: ${xhr.status}. Content: ${
                xhr.responseText
              }`,
            ),
          );
        }

        resolve(xhr.responseText);
      };
      xhr.send(file);
    });

  }

  post(url, data) {
    return axios.post(this._basePath + url, data)
    .then(
      (data) => {
        const persons = data.data;
        return persons;
      });
  }

  put(url, data) {
    return axios.put(this._basePath + url, data)
    .then(
      (data) => {
        const persons = data.data;
        return persons;
      });
  }

  delete(url) {
    return axios.delete(this._basePath + url)
    .then(
      (data) => {
        const persons = data.data;
        return persons;
      });
  }

  get(url, options) {
    return axios.get(this._basePath + url, options)
    .then((data, error) => {
      if (error) {
        return error;
      }
      const persons = data.data;
      return persons;
    })
  }

  setToken(token) {
    if (!Objects.isEmptyOrBlank(token)) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    }
  }
}

export function generateCancelRequestToken() {
  return axios.CancelToken.source()
}



// WEBPACK FOOTER //
// ./src/services/HttpRequest.js